import type { InventoryItem } from '@/modules/inventory/types';
import type { CommercialOperationType } from '@/modules/commercial/types';
import { isItemSelectableForCommercial } from '@/modules/commercial/utils/itemEligibility';

type OperationItemPickerProps = {
  items: InventoryItem[];
  operationType: CommercialOperationType;
  selectedIds: string[];
  disabled?: boolean;
  onChange: (ids: string[]) => void;
};

export function OperationItemPicker({
  items,
  operationType,
  selectedIds,
  disabled = false,
  onChange,
}: OperationItemPickerProps) {
  const eligible = items.filter((i) =>
    isItemSelectableForCommercial(i, operationType),
  );

  if (eligible.length === 0) {
    return (
      <p className="auth-muted">
        No hay artículos elegibles para este tipo de operación.
      </p>
    );
  }

  function toggle(id: string) {
    if (disabled) return;
    if (selectedIds.includes(id)) {
      onChange(selectedIds.filter((x) => x !== id));
    } else {
      onChange([...selectedIds, id]);
    }
  }

  return (
    <ul className="reservation-item-picker">
      {eligible.map((item) => (
        <li key={item.id}>
          <label className="auth-label auth-label--row">
            <input
              type="checkbox"
              disabled={disabled}
              checked={selectedIds.includes(item.id)}
              onChange={() => toggle(item.id)}
            />
            <span>
              <code>{item.sku}</code> — {item.name}
              <span className="auth-muted"> ({item.mode})</span>
            </span>
          </label>
        </li>
      ))}
    </ul>
  );
}
